import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { PositionsPanelComponent } from './lib/positions-panel.component'
import { PositionsKey } from './panel-key'

export const PositionsPanelConfig: PanelConfig = {
  key: PositionsKey,
  title: 'Positions',
  description:
    'View descriptions, differences, and historical balances of Clearwater and external holdings.',
  category: PanelCategory.ESSENTIALS,
  panelComponent: PositionsPanelComponent,
  accessPermission: 'accessPositionsPanel',
  isExternal: true,
}
